import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { useFetch } from '@/hooks/useFetch';
import { PageHeader } from '@/components/kit';
import { BackLink, recordGate } from '@/components/record';
import DiscountForm, { discountToForm } from '@/components/admin/DiscountForm';
import { DISCOUNT_FIELDS } from '@/shared/fields';
import { committed } from '@/shared/data';

export const route = { path: '/admin/discounts/:id/edit', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function EditDiscount() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const { data: code, loading, error, run } = useFetch(
    () => sdk.table('discount_codes_c').select(DISCOUNT_FIELDS).get(id).then((r) => r.data ?? null),
    [id],
  );

  const back = <BackLink to={`/admin/discounts/${id}`} label="Back to Code" />;
  const gate = recordGate({ back, loading, record: code, error, run, what: 'Discount code' });
  if (gate) return gate;

  async function save(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('discount_codes_c').update({ Id: code.Id, ...payload });
      if (!committed(res, 'Code saved')) return;
      navigate(`/admin/discounts/${code.Id}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-5xl">
      {back}
      <PageHeader eyebrow="Edit code" title={<span className="font-mono">{code.Name}</span>} />
      <DiscountForm
        key={code.Id}
        initial={discountToForm(code)}
        onSubmit={save}
        saving={saving}
        submitLabel="Save changes"
        cancelTo={`/admin/discounts/${code.Id}`}
      />
    </div>
  );
}
